import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KpiComponent } from './kpi/kpi.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [KpiComponent],
  exports: [KpiComponent]
})
export class KpiModule { }
